export type WaterMarkViewInitData = {
    gameName: string;
    isGlobalClockEnabled: boolean;
    isNetPositionEnabled: boolean;
    isElapsedTimeEnabled: boolean;
    isSessionEarningsEnabled: boolean;
    isSessionBetsEnabled: boolean;
    isShowMaxWinProbabilityEnabled: boolean;
    isRTPWatermarkEnabled: boolean;
};